import { render, staticRenderFns } from "./ClientesPorVendedor.vue?vue&type=template&id=c5d8740e&scoped=true"
import script from "./ClientesPorVendedor.vue?vue&type=script&lang=js"
export * from "./ClientesPorVendedor.vue?vue&type=script&lang=js"
import style0 from "./ClientesPorVendedor.vue?vue&type=style&index=0&id=c5d8740e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d8740e",
  null
  
)

export default component.exports